import hasItems from '@utils/cart/hasItems';
import getCart from './getCart';

const getCartHasItems = state => hasItems(getCart(state));

export default getCartHasItems;
